import React from 'react'
import { Redirect, useLocation, useParams } from 'react-router-dom'
import { reverse } from 'src/routes/config'

function RedirectRoute(props) {
    const { name } = props.route.redirect
    const params = useParams()
    const { search, hash } = useLocation()
    let strippedHash
    //Hash is provided with the anchor by default, and reverse expects it without
    if (hash && hash.startsWith('#')) {
        strippedHash = hash.replace('#', '')
    }
    const query = Object.fromEntries(new URLSearchParams(search))
    const redirectRoute = reverse(name, params, query, strippedHash)

    return <Redirect to={redirectRoute} />
}

export default RedirectRoute
